import React from 'react'
import s from '../css/notFound.module.css'

const NotFound = () => {
	return <h1 className={s.title}>Страница не найдена</h1>
}

export default NotFound
